<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="#" title="Home">CNA Box</a></li>
                            <li><a href="#" title="Pages">Gerencial</a></li>
                            <li>Vídeo Tutorial</li>
                        </ul>
                    </section>
                    <section class="col-sm-6">
                        <button class="btn-large-40 btn-success uppercase pull-right btn-header" @click="openCreate()">
                            Criar
                        </button>
                    </section>
                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Vídeo Tutorial</b></h2>
                    </div>

                    <div class="mold-txt-center">
                        <form v-on:submit.prevent="executeFilter(filter)">
                            <div class="row">

                                <div class="form-group col-md-6">
                                    <label for="tutorialVideoFuncionalidadeId">Funcionalidade do Video Tutorial</label>
                                    <select v-select="{ dataitem: 'TutorialVideoFuncionalidade', default: 'Selecione' }" v-model="filter.tutorialVideoFuncionalidadeId" class="form-control" name="tutorialVideoFuncionalidadeId" required></select>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="nome">Nome</label>
                                    <input type="text" class="form-control" name="nome" placeholder="Nome" v-model="filter.nome" required />
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="titulo">Título</label>
                                    <input type="text" class="form-control" name="titulo" placeholder="Título" v-model="filter.titulo" required />
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="descricao">Descrição</label>
                                    <textarea type="text" class="form-control" name="descricao" placeholder="Descrição" v-model="filter.descricao" />
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="uRLApresentacao">URL da Página</label>
                                    <input type="text" class="form-control" name="uRLApresentacao" placeholder="URL da Página" v-model="filter.urlApresentacao" required />
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="videoReferencia">Url do Vídeo</label>
                                    <input type="text" class="form-control" name="videoReferencia" placeholder="Url do Vídeo" v-model="filter.videoReferencia" required />
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="dtAtualizacao">Data Atualização</label>
                                    <input type="date" v-datepicker class="form-control" name="dtAtualizacao" v-model="filter.dtAtualizacao" />
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="ordemApresentacao">Ordem de Apresentação</label>
                                    <input type="text" class="form-control" name="ordemApresentacao" placeholder="Ordem de Apresentação" v-model="filter.ordemApresentacao" />
                                </div>

                                <div class="form-group col-md-2">
                                    <label>Ativo</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio">
                                            <input type="radio" name="ativo" v-model="filter.ativo" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio">
                                            <input type="radio" name="ativo" v-model="filter.ativo" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio">
                                            <input type="radio" name="ativo" v-model="filter.ativo" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>

                            </div>
                            <button type="button" class="btn-large-40 btn-red uppercase" @click="executeFilter(filter)">Buscar</button>
                        </form>
                    </div>

                    <div class="table-responsive standard-table header-cinza">
                        <table>
                            <thead>
                                <tr>
                                    <th>Vídeo Funcionalidade</th>
                                    <th>Nome<i @click="executeOrderBy('Nome')" class="fa fa-sort"></i></th>
                                    <th>Título<i @click="executeOrderBy('Titulo')" class="fa fa-sort"></i></th>
                                    <th>Pági0na de Apresentação<i @click="executeOrderBy('URLApresentacao')" class="fa fa-sort"></i></th>
                                    <th>Vídeo Referência<i @click="executeOrderBy('VideoReferencia')" class="fa fa-sort"></i></th>
                                    <th>Data Atualização<i @click="executeOrderBy('DtAtualizacao')" class="fa fa-sort"></i></th>
                                    <th>Ativo<i @click="executeOrderBy('Ativo')" class="fa fa-sort"></i></th>
                                    <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                    <td>{{ item.tutorialVideoFuncionalidade.nome }}</td>
                                    <td>{{ item.nome }}</td>
                                    <td>{{ item.titulo }}</td>
                                    <td>{{ item.urlApresentacao }}</td>
                                    <td>{{ item.videoReferencia }}</td>
                                    <td>{{ item.dtAtualizacao }}</td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.ativo, 'badge-danger': !item.ativo }">{{item.ativo ? 'Sim' : 'Não'}}</span></td>
                                    <td class="text-center">
                                        <template v-if="item.ativo === true">
                                            <button  type="button" class="btn btn-sm btn-warning" @click="openVisualizar(item)">
                                                <i class="fa fa-play"></i>
                                            </button>
                                        </template>                                        
                                        <button type="button" class="btn btn-sm btn-primary" @click="openEdit({ tutorialVideoId: item.tutorialVideoId })">
                                            <i class="fa fa-pencil"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-success" @click="openVideoTag({ tutorialVideoId: item.tutorialVideoId })">
                                            <i class="fa fa-tag"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-danger" @click="openRemove({ tutorialVideoId: item.tutorialVideoId })">
                                            <i class="fa fa-trash-o"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="card-block no-padding">
                        <pagination :total="result.total" :page-size="filter.pageSize" :callback="executePageChanged"></pagination>
                    </div>

                </div>
            </div>
        </section>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogCreate" size="lg" :hide-footer="true" title="Criar">
            <form-create v-if="dialogCreate" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogEdit" size="lg" :hide-footer="true" title="Editar">
            <form-edit v-if="dialogEdit" :id="tutorialVideoId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogVideoTag" size="lg" :hide-footer="true" title="Video Tag">
            <video-tag v-if="dialogVideoTag" :id="tutorialVideoId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal  :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogVisualizar" size="lg" title="Visualização">
            <div class="text-center">
                <iframe ref="videoGabriel" width="750" height="450"
                        :src="video"></iframe>
            </div>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="hideVideoModal()">
                    Fechar
                </button>
            </div>
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p style="margin-bottom:0;">Tem certeza que deseja remover este item?</p>
            <p>Não será possível desfazer essa ação</p>
            <div slot="modal-footer">
                <button type="button" class="btn btn-sm btn-danger" style="margin-right:5px;" @click="hideAll()">
                    Cancelar
                </button>
                <button type="button" class="btn btn-sm btn-primary" @click="executeRemove()">
                    Sim
                </button>                
            </div>
        </b-modal>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    import videoTag from './tutorialvideotag/index'
    import formCreate from './form-create'
    import formEdit from './form-edit'

    export default {
        name: 'tutorialvideo',
        mixins: [base],
        components: { formCreate, formEdit, videoTag },
        data() {
            return {

                resources: {
                    filter: 'tutorialvideo',
                    remove: 'tutorialvideo'
                },
                
                dialogVisualizar: false,
				dialogRemove: false,
                dialogCreate: false,
                dialogEdit: false,
                dialogVideoTag: false,
                video: '',
                model: {},
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                    tutorialVideoFuncionalidadeId: ''
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {
            openVideoTag: function (model) {
                this.tutorialVideoId = model.tutorialVideoId;
                this.dialogVideoTag = true;
            },
            openEdit: function (model) {
                this.tutorialVideoId = model.tutorialVideoId;
                this.dialogEdit = true;
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogEdit = false;
                this.dialogRemove = false;
                this.dialogVisualizar = false;
                this.dialogVideoTag = false;
            },
            hideVideoModal: function (){
                this.dialogVisualizar = false;
                this.video = '';
            },
            openVisualizar: function (model) {
                this.dialogVisualizar = true;
                this.video = model.videoReferencia;
            },
            openRemove: function (model) {
                this.dialogRemove = true;
                this.model = model;
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {
                this.showLoading();
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },

        mounted() {
            this.executeFilter();
        }

    };
</script>